import React from 'react';
import { Progress, Table, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

export default function RMultipleTable({ data, totalTrades }) {
    const columns = [
        {
            title: 'R Level',
            dataIndex: 'level',
            key: 'level',
            render: (text) => <Text strong>{text}</Text>
        },
        {
            title: 'Trades Reached',
            dataIndex: 'reached',
            key: 'reached',
            render: (val) => `${val} / ${totalTrades}`
        },
        {
            title: 'Percentage',
            dataIndex: 'percentage',
            key: 'percentage',
            render: (val) => {
                let strokeColor = '#ff4d4f';
                if (val >= 50) {
                    strokeColor = '#52c41a';
                } else if (val >= 25) {
                    strokeColor = '#faad14';
                }

                return (
                    <Progress
                        percent={val}
                        size="small"
                        format={(p) => `${p.toFixed(1)}%`}
                        strokeColor={strokeColor}
                    />
                );
            }
        }
    ];

    const dataSource = ['1R', '2R', '3R', '4R', '5R', '6R'].map((level, index) => ({
        key: index,
        level,
        reached: data[level]?.reached || 0,
        percentage: data[level]?.percentage || 0
    }));

    return <Table columns={columns} dataSource={dataSource} pagination={false} size="small" />;
}

RMultipleTable.propTypes = {
    data: PropTypes.objectOf(
        PropTypes.shape({
            reached: PropTypes.number,
            percentage: PropTypes.number
        })
    ).isRequired,
    totalTrades: PropTypes.number.isRequired
};
